import { render } from "./MerchantTerms.vue?vue&type=template&id=8067ac12&scoped=true"
import script from "./MerchantTerms.vue?vue&type=script&lang=js"
export * from "./MerchantTerms.vue?vue&type=script&lang=js"

import "./MerchantTerms.vue?vue&type=style&index=0&id=8067ac12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8067ac12"]])

export default __exports__